<script setup lang="ts">
import type { Blocks, ConfirmationPageContent, Metadata } from 'types';

const props = defineProps<{
  blocks: Blocks;
  content: ConfirmationPageContent;
  metadata: Metadata;
}>();

const computedBlocks = computed(() => {
  return props.blocks.blocks || {};
});
</script>

<template>
  <main>
    <BaseRte
      v-if="content.thankYouMessage"
      :content="content.thankYouMessage"
      class="narrow-container container py-10 lg:py-20"
    />

    <BlockList
      v-if="computedBlocks"
      :blocks="computedBlocks"
    />
  </main>
</template>
